import { AxiosResponse } from 'axios';

interface IHttpResponse {
  body: any;
  status: number;
  headers: object;
  error: HttpError | null;
}

interface HttpError {
  originalError: any;
  status: any;
}

export class HttpResponse implements IHttpResponse {
  body: any;
  status: number;
  headers: object;
  error: HttpError | null = null;

  constructor(httpResponse: AxiosResponse) {
    this.body = httpResponse.data;
    this.status = httpResponse.status;
    this.headers = httpResponse.headers;
  }
}
